import _ from 'lodash';
import { apiDefinitions } from './apiDefinitions';

export const api = _.mapValues(apiDefinitions, function(resource) {
  return resource.request.bind(null, resource.url);
});

export { makeRequest, unconfiguredCall, getResponseOr404 } from './makeRequest';
